import { REACT_APP_CLOUD_FRONT } from "../../../constants";

export const symbolDetails = {
    "vegetarian": {
      icon: `${REACT_APP_CLOUD_FRONT}/images/Menu/symbol-icons/Veg-icon.svg`,
      className: "tooltip-veg",
    },
    "keto": {
      icon: `${REACT_APP_CLOUD_FRONT}/images/Menu/symbol-icons/Keto-icon.svg`,
      className: "tooltip-keto",
    },
    "low calories": {
      icon: `${REACT_APP_CLOUD_FRONT}/images/Menu/symbol-icons/Low-cal-icon.svg`,
      className: "tooltip-low",
    },
    "high protein": {
      icon: `${REACT_APP_CLOUD_FRONT}/images/Menu/symbol-icons/High-pro-icon.svg`,
      className: "tooltip-high",
    },
    "dairy-free option": {
      icon: `${REACT_APP_CLOUD_FRONT}/images/Menu/symbol-icons/Dairy-free-icon.svg`,
      className: "tooltip-dairy",
    },
    "gluten free": {
      icon: `${REACT_APP_CLOUD_FRONT}/images/Menu/symbol-icons/Gluten-free-icon.svg`,
      className: "tooltip-dairy",
  },
  "contains milk": {
    icon: `${REACT_APP_CLOUD_FRONT}/tags/milk-allergen-icon.svg`,
    className: "tooltip-contain-milk",
  },
  "contains egg": {
    icon: `${REACT_APP_CLOUD_FRONT}/tags/egg-allergen-icon.svg`,
    className: "tooltip-contain-egg",
  },
  "contains wheat": {
    icon: `${REACT_APP_CLOUD_FRONT}/tags/wheat-allergen-icon.svg`,
    className: "tooltip-contain-wheat",
  },
  "contains pistachio": {
    icon: `${REACT_APP_CLOUD_FRONT}/tags/pistachio-allergen-icon.svg`,
    className: "tooltip-contain-pistachio",
  },
  "contains cashew": {
    icon: `${REACT_APP_CLOUD_FRONT}/tags/cashew-allergen-icon.svg`,
    className: "tooltip-contain-cashew",
  },
  "contains hazelnuts": {
    icon: `${REACT_APP_CLOUD_FRONT}/tags/hazelnut-allergen-icon.svg`,
    className: "tooltip-contain-hazelnuts",
  },
  "contains coconut milk": {
    icon: `${REACT_APP_CLOUD_FRONT}/tags/coconut-milk-allergen-icon.svg`,
    className: "tooltip-contain-coconut-milk",
  },
  "contains coconut oil": {
    icon: `${REACT_APP_CLOUD_FRONT}/tags/coconut-oil-allergen-icon.svg`,
    className: "tooltip-contain-coconut-oil",
  },
  "contains almond": {
    icon: `${REACT_APP_CLOUD_FRONT}/tags/almond-allergen-icon.svg`,
    className: "tooltip-contain-almond",
  },
  "contains soy": {
    icon: `${REACT_APP_CLOUD_FRONT}/tags/soy-allergen-icon.svg`,
    className: "tooltip-contain-soy",
  },
  "contains sesame": {
    icon: `${REACT_APP_CLOUD_FRONT}/tags/sesame-allergen-icon.svg`,
    className: "tooltip-contain-sesame",
  },
  "contains fish": {
    icon: `${REACT_APP_CLOUD_FRONT}/tags/fish-allergen-icon.svg`,
    className: "tooltip-contain-fish",
  },
  "contains shellfish": {
    icon: `${REACT_APP_CLOUD_FRONT}/tags/shellfish-allergen-icon.svg`,
    className: "tooltip-contain-shellfish",
  },
  "contains pecan": {
    icon: `${REACT_APP_CLOUD_FRONT}/tags/pecan-allergen-icon.svg`,
    className: "tooltip-contain-pecan",
  },
  }